import { useFormik } from 'formik'
import { useEffect } from 'react'
import { InviteEmailInput as Input } from 'ui-components'
import * as Yup from 'yup'
import { useInviteUserToMapByEmail } from '~map-preview/hooks/useInviteUserToMapByEmail'
import { useSetInput } from '~map-preview/states/mapShare'

export const InviteEmailInput = () => {
  const setInput = useSetInput()
  const { invite } = useInviteUserToMapByEmail()
  const form = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('Invalid email')
    }),
    onSubmit: async (values, helpers) => {
      await invite(values.email)
      helpers.resetForm()
    }
  })

  useEffect(() => {
    setInput(form.values.email)
  }, [form.values.email])

  return (
    <form
      data-testid='EmailForm'
      onSubmit={form.handleSubmit}
    >
      <Input
        autoFocus
        value={form.values.email}
        onChange={form.handleChange('email')}
        disabled={form.isSubmitting}
        ButtonProps={{
          loading: form.isSubmitting,
          disabled: !form.isValid || !form.dirty
        }}
      />
    </form>
  )
}
